import { USER_LOGOUT } from '@/store/actions.type'
import { mapActions, mapGetters } from 'vuex'
import {CHECK_REGISTERED_BROKER_USER} from '@/store/actions.type'
import marquee from '@/components/marquee.vue'

export default {
    data () {
        return {
            isLoggedin: false,
            registeredBrokerUser:false,
            isMSIUser: false
        }
    },
    components: {
        marquee
    },
    created () {
        if (localStorage.getItem('isMSIUser') === 'true') {
            this.isMSIUser = true
        }
        this.checkauth()
    },

    computed: {
        userDetails () {
            this.checkauth()
            return this.$store.state.authentication.user
        },
        isRedirectedBrokerUrl(){
            return (localStorage.getItem('utmParams')==undefined || localStorage.getItem('utmParams')==null )?false:true;
        }
    },

    methods: {

        ...mapActions({
            userlogout: USER_LOGOUT,
            isRegisteredBrokerUserCall:CHECK_REGISTERED_BROKER_USER
        }),

        async logout () {
            var self = this;
            localStorage.removeItem("utmParams")
            localStorage.removeItem("preLoginHoldingsData")
            await this.userlogout().then(data => {
                self.$store.commit('LOGOUT_USER');
                self.$router.replace('/');
                window.location.reload();
            });
        },

        async checkauth () {
            if (localStorage.getItem('psitoken')) {
                this.isLoggedin = true;
            }
            else {
                this.isLoggedin = false;
            }
        },

        async isRegisteredBrokerUser(){
            await this.isRegisteredBrokerUserCall(localStorage.getItem('utmParams')).then(response => {
              if(response.data.succcess==true)
              {
                  this.registeredBrokerUser=true
              }
            });
        },

        loginbtn (postId) {
          this.$router.push("/login/" + postId);
      },


    }
}




// WEBPACK FOOTER //
// ./src/assets/js/newheader.js